import { useState, useEffect } from 'react'
import { getChecklistNotebookTypeAPI } from '../services/checklist'
function UseNotebookType() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await getChecklistNotebookTypeAPI()
      if (!resp) return
      if (resp.status) {
        const newData = resp.result.map((d) => {
          return { value: d.equipPdId, label: d.equipPdName }
        })

        setData(newData)
      } else {
        setData([])
      }
    }
    getData()
  }, [])

  return data
}

export default UseNotebookType
